/* eslint-disable react/no-array-index-key */
import React from 'react';

import { Heading, Paragraph, Link } from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { TaggedAccordion } from 'client/components/taggedAccordion/TaggedAccordion';
import testIds from 'client/testIds';

import BackToTopLink from './BackToTopLink';
import { LimitedCompanyCriteriaContent } from '../LimitedCompanyCriteria.config';

function ApplicationSection() {
  const { application, backToTopLabel, jumpToASection } =
    useContent<LimitedCompanyCriteriaContent>();

  const {
    id,
    title,
    directorsAndShareholders,
    decisionInPrinciple,
    directDebitDetails,
  } = application;

  return (
    <section
      id={id}
      data-testid={testIds.limitedCompanyCriteria.applicationSection}
    >
      <Heading
        size="s5"
        marginBottom="05"
        marginTop="05"
        as="h2"
        dataTestId={testIds.limitedCompanyCriteria.applicationHeading}
      >
        {title}
      </Heading>

      <TaggedAccordion
        label={
          <Heading size="s3" as="h3">
            {directorsAndShareholders.title}
          </Heading>
        }
        id={directorsAndShareholders.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.directorsAndShareholders}
      >
        {directorsAndShareholders.paragraphs.map((item, idx) => (
          <Paragraph key={`directors-and-shareholders-${idx}`}>
            {item}
          </Paragraph>
        ))}
        <Paragraph>
          <Link href={directorsAndShareholders.link.url}>
            {directorsAndShareholders.link.label}
          </Link>
        </Paragraph>
      </TaggedAccordion>

      <TaggedAccordion
        label={
          <Heading size="s3" as="h3">
            {decisionInPrinciple.title}
          </Heading>
        }
        id={decisionInPrinciple.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.decisionInPrinciple}
      >
        <Paragraph>{decisionInPrinciple.paragraph1}</Paragraph>
      </TaggedAccordion>

      <TaggedAccordion
        label={
          <Heading size="s3" as="h3">
            {directDebitDetails.title}
          </Heading>
        }
        id={directDebitDetails.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.directDebitDetails}
      >
        <Paragraph>{directDebitDetails.paragraph1}</Paragraph>
      </TaggedAccordion>

      <BackToTopLink
        dataTestId={`${id}-back-to-top`}
        jumpToASectionId={jumpToASection.id}
      >
        {backToTopLabel}
      </BackToTopLink>
    </section>
  );
}

export default ApplicationSection;
